import { render, staticRenderFns } from "./DefaultAccordionItem.vue?vue&type=template&id=a738a534&scoped=true&"
import script from "./DefaultAccordionItem.vue?vue&type=script&lang=js&"
export * from "./DefaultAccordionItem.vue?vue&type=script&lang=js&"
import style0 from "./DefaultAccordionItem.vue?vue&type=style&index=0&id=a738a534&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a738a534",
  null
  
)

export default component.exports